<template>
  <div
    class="w-100 h-100 p-3 McsBgImg overflow-auto"
    :style="`background: rgba(${MgmData.bgColor}, 1.0);`"
  >
    <!-- 自訂背景色 -->
    <!-- MGM活動頁 begin -->
    <div
      class="container p-0 mx-auto rounded-lg shadow-custom overflow-hidden"
      style="max-width:640px;background: rgba(255,255,255,1);color: rgba(0,0,0, 0.87);"
    >
      <!-- 遮罩 -->
      <!-- banner-如不上圖就整個div摘掉 begin -->
      <div v-if="showBanner">
        <img
          :src="MgmData.themeMainImg"
          class="w-100"
          @error="showBanner = false"
        >
      </div>
      <!-- banner-如不上圖就整個div摘掉 end -->
      <div
        class="mx-auto p-3"
        style="max-width:480px;"
      >
        <slot />
      </div>
    </div>
    <!-- MGM活動頁 end -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import McsBgImg from '@/assets/users/bg-party.jpg';

export default {
  data() {
    return {
      Img: McsBgImg,
      showBanner: true,
    };
  },
  created() {

  },
  computed: {
    ...mapState([
      'MgmData',
    ]),
  },
  components: {

  },
};
</script>

<style>
.McsBgImg{  background-size: cover !important; }
</style>
